<template>
  <v-menu
    v-model="deadlineMenu"
    :disabled="disabled"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="deadline"
        :label="label"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        style="max-width: 480px"
      ></v-text-field>
    </template>
    <v-date-picker
      :value="deadline"
      @input="onDateInput"
      locale="ru-ru"
      :first-day-of-week="1"
      :min="minDate"
      :max="maxDate"
    ></v-date-picker>
  </v-menu>
</template>

<script>
/**
 * v-date-picker accepts ISO 8601 date strings (date only!) (YYYY-MM-DD)
 */

export default {
  model: {
    prop: 'deadline',
  },
  data() {
    return {
      deadlineMenu: false,
    }
  },
  props: {
    label: {
      type: String,
      default: 'Крайний срок',
    },
    deadline: {
      type: String,
    },
    minDate: {
      type: String,
    },
    maxDate: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onDateInput(value) {
      this.deadlineMenu = false
      this.$emit('input', value)
    },
  },
}
</script>
